<template>
    <v-content>
      <v-container
      >
        <v-layout
          flex
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm4
          >
            <h1>Change your password</h1>
            <h5>Enter a new password</h5>
            <ValidationObserver ref="observer" tag="form" @submit.prevent="resetPassword">
            <ValidationProvider rules="required|min:5|max:20" v-slot="{ errors, valid }" name='password'>
                <v-text-field
                label="New Password"
                v-model="form.password"
                data-vv-name="password"
                data-vv-validate-on="none"
                autocomplete="false"
                class="input"
                :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                @click:append="() => (hidePassword = !hidePassword)"
                :type="hidePassword ? 'password' : 'text'"                    
                :success="valid"
                :error-messages="errors"
                />                    
            </ValidationProvider>
            <ValidationProvider rules="required|confirmPassword:@password" v-slot="{ errors, valid }" name='password_confirmation'>
                <v-text-field
                label="Confirm new password"
                v-model="form.password_confirmation"
                data-vv-name="password_confirmation"
                data-vv-validate-on="none"
                autocomplete="false"
                :append-icon="hidePassword2 ? 'visibility' : 'visibility_off'"
                @click:append="() => (hidePassword2 = !hidePassword2)"
                :type="hidePassword2 ? 'password' : 'text'"
                :success="valid"
                :error-messages="errors"
                ></v-text-field>                    
            </ValidationProvider>
            <v-layout
                justify-space-between
                class="mt-2"
            >
                <v-btn type="submit" outlined color="primary">Update</v-btn>
                <v-btn outlined color="primary" @click="$router.go(-1)">Cancel</v-btn>
            </v-layout>
            </ValidationObserver>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </template>
  
  <script>
  import AppConfig from '@/config/appConfig'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import validations from '@/modules/validations'
  import storageUtil from '@/helpers/storage'
  
  export default {
    components: {
      ValidationProvider,
      ValidationObserver
    },
    data () {
      return {
        hidePassword: true,
        hidePassword2: true,
        form: {
          password: null,
          token: null,
          email: this.$store.getters.getUser.email,
          app:'ayres_core'
        },
        appLogo: AppConfig.appLogo2
      }
    },
    methods: {
      resetPassword () {
        const vm = this
        const token = storageUtil.getKey('auth_token')
        vm.form.token = token
        vm.$refs.observer.validate().then((valid) => {
          if (valid) {
            storageUtil.setKey('auth_token', this.$route.params.token)
            vm.$store.dispatch('resetPassword', {
              credentials: vm.form
            })
          }
        })
      }
    }
  
  }
  </script>
  <style scoped>
    .v-toolbar__title {
      width: 100%;
    }
    h1 {
      font-weight: 600;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      text-align: left;
      color: black;
    }
    .login-box {
      border: 2px solid #244AB3;
      border-radius: 10% !important;
      min-height: 350px;
      min-width: 450px;
    }
    .logo {
      left: 40px;
    }
    .btn-login {
      border-radius: 45px;
      min-height: 48px;
      color: #244AB3;
    }
    .v-btn{
      text-transform: none !important;
    }
    .pt-4 {
      padding-top: 40px !important;
    }
    .wrapper-button {
      display: -webkit-box;
    }
    .v-btn {
      margin: 0 auto;
      display: flex;
    }
    </style>
    